import Api from '@/api'

export default {
  namespaced: true,

  state: {
    expiringTradieFiles: [],
    expiringTradieFilesMeta: null,
  },

  getters: {
    expiringTradieFiles(state) {
      return state.expiringTradieFiles
    },
    expiringTradieFilesMeta(state) {
      return state.expiringTradieFilesMeta
    },
  },

  mutations: {
    setExpiringTradieFiles(state, expiringTradieFiles) {
      state.expiringTradieFiles = expiringTradieFiles
    },
    clearExpiringTradieFiles(state) {
      state.expiringTradieFiles = []
    },

    setExpiringTradieFilesMeta(state, expiringTradieFilesMeta) {
      state.expiringTradieFilesMeta = expiringTradieFilesMeta
    },
    clearExpiringTradieFilesMeta(state) {
      state.expiringTradieFilesMeta = null
    },
  },

  actions: {
    async getExpiringTradieFiles({ commit }, params) {
      commit('clearExpiringTradieFiles')

      await new Promise(async (resolve, reject) => {
        const qs = new URLSearchParams()
        qs.set('limit', String(params.limit))
        qs.set('page', String(params.page))
        qs.set(
          'project_id',
          String(params.projectId != null ? params.projectId : 0),
        )
        if (params.sortBy) {
          qs.set('sort_by', params.sortBy)
          qs.set('sort_dir', params.sortDesc ? 'desc' : 'asc')
        }
        const search = params.search != null ? String(params.search).trim() : ''
        if (search) {
          qs.set('search', search)
        }

        await Api.get(`company-files/expiring-tradie-files?${qs.toString()}`)
          .then((res) => {
            commit('setExpiringTradieFiles', res.data.data)
            commit('setExpiringTradieFilesMeta', res.data.meta)
            resolve(res)
          })
          .catch((err) => reject(err.response))
      })
    },

    async setCompanyApproval(_, { fileId, status, reason, projectId } = {}) {
      if (!fileId) {
        throw new Error('fileId is required to set company approval.')
      }
      if (
        status !== 'approved' &&
        status !== 'rejected' &&
        status !== 'pending' &&
        status !== 'not_applicable'
      ) {
        throw new Error(
          'status must be "approved", "rejected", "pending", or "not_applicable".',
        )
      }
      if (status === 'rejected' && !reason) {
        throw new Error('reason is required when rejecting a file.')
      }
      if (projectId == null) {
        throw new Error('projectId is required to set company approval.')
      }

      const payload = { status, project_id: projectId }
      // Rejected requires a reason; approved, pending, and not_applicable each
      // accept an optional comment from the BA.
      if (status === 'rejected') {
        payload.reason = reason
      } else if (reason) {
        const trimmed = String(reason).trim()
        if (trimmed) payload.reason = trimmed
      }

      const { data } = await Api.patch(
        `company-files/${fileId}/company-approval`,
        payload,
      )
      return data && data.data ? data.data : data
    },

    async requestFileRenewal(_, { fileId, message, dueDate } = {}) {
      if (!fileId) {
        throw new Error('fileId is required to request a renewal.')
      }

      const payload = {}

      if (message) {
        payload.message = message
      }

      if (dueDate) {
        payload.due_date = dueDate
      }

      return new Promise(async (resolve, reject) => {
        await Api.post(`company-files/${fileId}/request-renewal`, payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err.response))
      })
    },
  },
}
